import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { PromptComponent } from './prompt.component';
import { PromptEditComponent } from './prompt-edit/prompt-edit.component';

@NgModule({
    declarations: [
        PromptComponent,
        PromptEditComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule
    ],
    exports: [
        PromptComponent,
        PromptEditComponent
    ]
})
export class PromptModule { }
